import { IFetchedAIRecommendation } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

//이미지 업로더 - AI 추천 필터 및 태그 불러오기
async function getImageUploaderAIRecommendation(variables: {
  s3Path: string;
  key: string;
}): Promise<AxiosResponse<FetchResult<IFetchedAIRecommendation>>> {
  const response = await instance.get(`/images/tag-suggestions?s3Path=${variables.s3Path}&key=${variables.key}`);
  return response;
}

// 사용자 액션에 따라 데이터를 조회해야 하므로 useMutation 이용
const useFetchImageUploaderAIRecommendation = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['get', `/images/tag-suggestions`],
    mutationFn: (variables: { s3Path: string; key: string }) => getImageUploaderAIRecommendation(variables),
    retry: false
  });

  return { mutateAsync, isPending };
};

export default useFetchImageUploaderAIRecommendation;
